import DiffReport from './DiffReport';
import CorrectAnswers from './CorrectAnswers';
export default [DiffReport, CorrectAnswers];
